module.exports = __webpack_public_path__ + "img/goal02_over.499f5030.png";